import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.COMPANY_CODES);

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].enabledFlagValues,
  enabledFlagValues => enabledFlagValues.map(({ name, value }) => ({ label: name, value }))
);

export const yesNoOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].yesNoOptionalValues,
  yesNoOptionalValues => yesNoOptionalValues.map(({ name, value }) => ({ label: name, value }))
);

export const chartNameOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].chartNames,
  chartNames => chartNames
    .filter(({ chartName }) => !!chartName)
    .map(({ chartName }) => ({
      label: chartName,
      value: chartName,
    }))
);

export const connectionNameOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].connectionNames,
  connectionNames => connectionNames
    .filter(({ connectionName }) => !!connectionName)
    .map(({ connectionName }) => ({
      label: connectionName,
      value: connectionName,
    }))
);

export const legalEntityOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].legalEntities,
  legalEntities => legalEntities.map(({
    legalEntity,
    leDescription,
    countryCode,
  }) => ({
    label: leDescription,
    value: legalEntity,
    countryCode,
  }))
);

export const businessUnitOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].businessUnits,
  businessUnits => businessUnits.map(({
    businessUnit,
    buDescription,
  }) => ({
    label: buDescription,
    value: businessUnit,
  }))
);

export const businessCodeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].businessCodes,
  businessCodes => businessCodes.map(({
    businessCode,
    businessLongDescription,
  }) => ({
    label: businessLongDescription,
    value: businessCode,
  }))
);

export const countryCodeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].countryCodes,
  countryCodes => countryCodes.map(({
    countryCode,
    countryDescription,
  }) => ({
    label: countryDescription,
    value: countryCode,
  }))
);

export const currencyCodeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].currencyCodes,
  currencyCodes => currencyCodes
    .filter(({ currencyCode }) => !!currencyCode)
    .map(({ currencyCode }) => ({
      label: currencyCode,
      value: currencyCode,
    }))
);

export const usShareholderFlagOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].usShareholderFlagValues,
  usShareholderFlagValues => usShareholderFlagValues.map(({ name, value }) => ({ label: (value ? (`${value } - ${ name}`) : ''), value }))
);

export const homeOfficeCompanyCodeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].homeOfficeCompanyCodeOptions,
  companyCodeOptions => companyCodeOptions.map(({
    companyCode,
    fullDesc,
    connName,
    subledgerFlag,
  }) => ({
    label: fullDesc,
    value: companyCode,
    connName,
    subledgerFlag,
  }))
);

export const companyCodesOptionsToValidateSelector = createSelector(
  state => state.administration[adminPageNames.COMPANY_CODES].companyCodesOptionsToValidate,
  companyCodeOptions => companyCodeOptions.map(({
    companyCode,
    fullDesc,
    connName,
    subledgerFlag,
  }) => ({
    label: fullDesc,
    value: companyCode,
    connName,
    subledgerFlag,
  }))
);

export const sourceOptionsSelector = state => state.administration[adminPageNames.COMPANY_CODES].sourceOptions;

export const fetchingDataForModalSelector = state =>
  state.administration[adminPageNames.COMPANY_CODES].fetchingDataForModal;

export const isRefreshingObligationsSelector = state =>
  state.administration[adminPageNames.COMPANY_CODES].isRefreshingObligations;
